import React from 'react'
import "./hero.scss"
import img1 from "../../images/association-dance-flowers2.jpg"
function Header() {
  return (
    <div className='hero1'><div class="hero">  
  <div className='anima'>
        <button aria-pressed="false" onClick="this.setAttribute('aria-pressed',this.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');"></button>

<div class='marquees'>
	<section class='marquee' > <style>{`  { --char-count: 28} `}</style>
		<div class='marquee--inner'>
			<p>Association</p>
			<p aria-hidden='true'>Association</p>
			<p aria-hidden='true'>Association</p>
			<p aria-hidden='true'>Association</p>
			<p aria-hidden='true'>Association</p>
						<p aria-hidden='true'>Association</p>
		</div>
	</section>

	<div class='marquee' > <style>{`  { --char-count: 30} `}</style>
		<div class='marquee--inner'>
			<p>Dance Flowers</p>
			<p aria-hidden='true'>Dance Flowers</p>
			<p aria-hidden='true'>Dance Flowers</p>
			<p aria-hidden='true'>Dance Flowers</p>
			<p aria-hidden='true'>Dance Flowers</p>
						<p aria-hidden='true'>Dance Flowers</p>
		</div>
	</div>

	<section class='marquee' > <style>{`  { --char-count: 22} `}</style>
		<div class='marquee--inner'>
    <p>Association</p>
			<p aria-hidden='true'>Association</p>
			<p aria-hidden='true'>Association</p>
			<p aria-hidden='true'>Association</p>
			<p aria-hidden='true'>Association</p>
						<p aria-hidden='true'>Association</p>
		</div>
	</section>

	<section class='marquee' > <style>{`  { --char-count: 24} `}</style>
		<div class='marquee--inner'>
    <p>Dance Flowers</p>
			<p aria-hidden='true'>Dance Flowers</p>
			<p aria-hidden='true'>Dance Flowers</p>
			<p aria-hidden='true'>Dance Flowers</p>
			<p aria-hidden='true'>Dance Flowers</p>
						<p aria-hidden='true'>Dance Flowers</p>
		</div>
	</section>
</div>
   

  </div>
    </div>
  
  <div class="section">
	
    <div class="content">
		 
      <h2>Qui sommes nous ?</h2>
      <p className='paragraphe'>
	  L’Association Danse Flowers se trouve à la Ravine Blanche, ouverte depuis 2006, c'est un lieu de partage et d’expression artistique au cœur de Saint-Pierre. Forte de sa mission de promouvoir la diversité culturelle à travers la danse, elle propose une large gamme de styles, allant de la K-pop au coupé-décalé, en passant par le Bollywood, le séga et la danse contemporaine. 
      </p>
    </div>
  </div>
  <div class="section">
    <div class="content">
      
      <p className='paragraphe'>
	  Ouverte à tous les passionnés, débutants comme confirmés, l’association organise des cours, des spectacles et des événements pour faire rayonner les danses du monde et offrir à chacun l’opportunité de s’épanouir à travers le mouvement et la musique.
	  
      </p>
    </div>{/* <div class="hero__bg"></div>
    <h1>
     Dance Flowers
    </h1> */}<img src={img1} class="img-head" alt="groupe,Dance Flowers"/>
  </div></div>
  )
}

export default Header 
